// extracted by mini-css-extract-plugin
module.exports = {"PageError":"styles_PageError__NHSGK","PageError__content":"styles_PageError__content__59apv"};